import { useToast } from "@/hooks/use-toast"
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "@/components/ui/toast"
import { useTranslation } from "@/hooks/useTranslation"
import { translations } from "@/i18n/translations"

export function Toaster() {
  const { toasts } = useToast()
  const { t } = useTranslation()

  const maybeTranslate = (val: React.ReactNode) => {
    if (typeof val === 'string' && translations[val]) {
      return t(val)
    }
    return val
  }

  return (
    <ToastProvider>
      {toasts.map(function ({ id, title, description, action, ...props }) {
        const resolvedTitle = maybeTranslate(title)
        const resolvedDesc = maybeTranslate(description)
        return (
          <Toast key={id} {...props}>
            <div className="grid gap-1">
              {resolvedTitle && <ToastTitle>{resolvedTitle}</ToastTitle>}
              {resolvedDesc && (
                <ToastDescription>{resolvedDesc}</ToastDescription>
              )}
            </div>
            {action}
            <ToastClose />
          </Toast>
        )
      })}
      <ToastViewport />
    </ToastProvider>
  )
}
